import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import InstagramAnalyzer from './components/InstagramAnalyzer/InstagramAnalyzer';

function App() {
  return (
    <div className="App">
      <Header />
      <main className="main-content">
        <InstagramAnalyzer />
      </main>
      <Footer />
    </div>
  );
}

export default App;
